import axios from "axios";
import { ApiError } from "../../Models/ApiError";
import { HandleError } from "../../Helpers/ErrorHandler";
import { StockCheck } from "../../Models/StockCheck";

const API_URL = process.env.REACT_APP_API_URL;

//an item's stock levels and price. Stock codes can contain '/', so the code goes in the query string.
export const getStockCheckAPI = async (stockCode: string, serverUrl: string, dbKey: string): Promise<StockCheck> => {
  return new Promise<StockCheck>((resolve, reject) => {
    axios
      .get<StockCheck>(`${API_URL}stockcheck?stockCode=${encodeURIComponent(stockCode)}&serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
